export type UIBehavior = "hidden" | "disabled";

export const UI_RULES: Record<string, Record<string, UIBehavior>> = {
  dataCA: {
    "type-insp": "disabled",
    "insp-move-btn": "hidden",
  },
};
